import './App.scss';
import React, { useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate
} from "react-router-dom";

import NavbarDesktop from './components/navbar/NavbarDesktop';
import NavbarMobile from './components/navbar/NavbarMobile';

import Home from './pages/HomePage/Home';
import About from './pages/AboutPage/About';
import Services from './pages/ServicesPage/Services';
import Galerie from './pages/GaleriePage/Galerie';
import Contact from './pages/ContactPage/Contact';
import MentionsLegales from './pages/MentionsLegales.js/MentionsLegales';

import Footer from './components/footer/FooterAllPages';

function App() {

    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const checkScrollTop = () => {
            if (window.pageYOffset > 400) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

        window.addEventListener('scroll', checkScrollTop);

        // Nettoyez l'écouteur d'événements lors du démontage du composant
        return () => {
            window.removeEventListener('scroll', checkScrollTop);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="app-container">
            <Router>

                <NavbarDesktop />
                <NavbarMobile />

                <Routes>
                    <Route path="/" element={<Navigate to="/home" />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/galerie" element={<Galerie />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/mentionsLegales" element={<MentionsLegales />} />
                </Routes>
        
                {showScroll && <button className="scrollToTop" onClick={scrollToTop}>↑</button>}
        
                <Footer />

            </Router>
        </div>
    );
}

export default App;

